import { ModalOption } from '@vae/server/src/types/notifications'
import React, { useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import useUser from '../contexts/hooks/useUser'
import { ModalContext } from '../contexts/ModalContext'
import AppRouter from '../pages/system/AppRouter'
import AnalyticsWrapper from '../wrappers/AnalyticsWrapper'

export const AppContent: React.FC = () => {
	const history = useHistory()
	const location = useLocation()
	// const { loggedIn, user, isAnonymousUser } = useContext(UserContext)

	const { user, isAuthenticated } = useUser()

	const { insertModal } = useContext(ModalContext)

	useEffect(() => {
		const params = new URLSearchParams(location.search)
		const modalRedirect = params.get('modalRedirect')

		if (modalRedirect && isAuthenticated && user) {
			insertModal(modalRedirect as ModalOption)

			params.delete('modalRedirect')
			const newUrl = `${location.pathname}${params.toString() ? `?${params.toString()}` : ''}`
			history.replace(newUrl)
		}
	}, [location.search, isAuthenticated, user, insertModal, history, location.pathname])

	return (
		<AnalyticsWrapper>
			<AppRouter />
		</AnalyticsWrapper>
	)
}
